import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.70711 14L8.12132 12.5858L3.88905 8.35352H17.3536V6.35352L3.76781 6.35352L8.12132 2L6.70711 0.585787L0 7.29289L6.70711 14Z",
		fill: "#333333"
	})
});
export default SvgArrowLeft;
